const location = window.location.origin;

export const getDomain = () => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  // Dev: same origin + setupProxy.js → Symfony (no CORS)
  return location;
};

const api = `${getDomain()}/api/v2/client`;

export default async function fetchRequest(url, options) {
  try {
    const response = await fetch(`${api}${url}`, options);
    const responseData = await response.json();
    return {
      status: response.status,
      data: await responseData,
      ok: response.ok,
    };
  } catch (error) {
    return { status: 500, ok: false, data: null };
  }
}
